var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_586_6023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.610352,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_586_6023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87472 14.4662V4.98535C9.87472 4.80799 9.93458 4.65952 10.0543 4.53993C10.1739 4.42021 10.3224 4.36035 10.4997 4.36035C10.6771 4.36035 10.8256 4.42021 10.9451 4.53993C11.0649 4.65952 11.1247 4.80799 11.1247 4.98535V14.4662L15.4324 10.1585C15.5563 10.0346 15.7013 9.97341 15.8674 9.97494C16.0335 9.9766 16.1812 10.042 16.3106 10.1712C16.4312 10.3005 16.4937 10.4469 16.4981 10.6104C16.5024 10.7738 16.4399 10.9202 16.3106 11.0495L11.027 16.3331C10.949 16.4111 10.8667 16.4661 10.7801 16.4981C10.6936 16.5301 10.6001 16.5462 10.4997 16.5462C10.3993 16.5462 10.3058 16.5301 10.2193 16.4981C10.1328 16.4661 10.0505 16.4111 9.97243 16.3331L4.68889 11.0495C4.57347 10.9341 4.51444 10.7912 4.5118 10.6208C4.50916 10.4504 4.56819 10.3005 4.68889 10.1712C4.81819 10.042 4.96666 9.97743 5.1343 9.97743C5.30208 9.97743 5.45062 10.042 5.57993 10.1712L9.87472 14.4662Z",
    fill: "#3F3273"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.df187fc11676c2e597aca790c2f97286.svg";
export { ForwardRef as ReactComponent };